import React, { useEffect, Suspense, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AdminRoutes, ReferrerRoutes, SuperAdminRoutes } from './routers';
import { useDispatch } from 'react-redux';
import { checkuser, userLogout } from './actions/user';
// @ts-ignore
import { setAccessToken, getAccessToken } from './auth';
import NotFoundPage from './pages/NotFoundPage';
import { Spin } from 'antd';
import { Workbox } from 'workbox-window';
import { useSelector } from 'react-redux';

// if ('serviceWorker' in navigator) {
//   const wb = new Workbox('/service-worker.js');

//   wb.register();
// }

const AppRoute = () => {
    const dispatch = useDispatch();
    const user = useSelector((state: any) => state?.Auth);
    const [loading, setLoading] = useState(true)
    const token = getAccessToken()
    
    useEffect(() => {
        dispatch(checkuser((res: any) => {
            if(res?.status === 401) {
                setAccessToken('');
                sessionStorage.removeItem('token');
                localStorage.removeItem('token')
                dispatch(userLogout((resp: any) => { }))
            }
        }));
    }, [token]);

    const [initialRoutes, setInitialRoutes] = useState<any>(AdminRoutes)

    let adminRoutes = AdminRoutes;
    const userData: any = user?.user?.data || user?.user?.user;


    useEffect(()=> {
        if(!userData?.roleId) {
            setLoading(true)
        } else {
            setLoading(false);
            if (userData?.roleId === 1) {
                adminRoutes = SuperAdminRoutes;
                setInitialRoutes(SuperAdminRoutes);
            } else if (userData?.roleId === 2) {
                adminRoutes = AdminRoutes;
                setInitialRoutes(AdminRoutes)
            } else if (userData?.roleId === 3) {
                adminRoutes = ReferrerRoutes;
                setInitialRoutes(ReferrerRoutes)
            }
        }

        setTimeout(()=> {
            setLoading(false)
        }, 4000)
    }, [userData])

    // ********* Service worker for PWA *********** //
    if ('serviceWorker' in navigator) {
        // window.addEventListener('load', () => {
        //   navigator.serviceWorker.register('../service-worker.js')
        //     .then(registration => {
        //       console.log('SW registered: ', registration);
        //     })
        //     .catch(registrationError => {
        //       console.log('SW registration failed: ', registrationError);
        //     });
        // });

        const wb = new Workbox('/service-worker.js');

        wb.register();
        // window.addEventListener('install', (event) => {
        //     event.waitUntil(
        //       caches.open('my-cache').then((cache) => {
        //         return cache.addAll([
        //           '/',
        //           '/index.html',
        //           '/styles.css',
        //           '/script.js',
        //         ]);
        //       }),
        //     );
        //   });
    }
    self.addEventListener('install', (event) => {
        console.log('Service Worker installing...');
    });
    
    self.addEventListener('activate', (event) => {
        console.log('Service Worker activating...');
    });

    if(loading) {
        return <Spin fullscreen>Loading... </Spin>
    }

    return (
        <Router>
            <Suspense
                fallback={<Spin
                    spinning={true}
                    delay={500}
                    tip="Loading..."
                    size="large"
                    fullscreen
                    wrapperClassName="spin-demo"
                />}>
                <Routes>
                    {initialRoutes.map((route: any, index:number) => {
                        const { layout: Layout, component: Component } = route;
                        return (
                            <Route
                                key={index}
                                path={route.path}
                                element={
                                    <Layout>
                                        <Component />
                                    </Layout>
                                }
                            />
                        );
                    })}
                    {/* Add a not found route */}
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
            </Suspense>
        </Router>
    );
};

export default AppRoute;